
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { ServicerSource } from '@/Sources';
  import { IServicer } from '@/Interfaces';

  @Component({
    name: 'servicer-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class ServicerDropdownField extends Vue {
    @Prop() public value!: unknown;
    @Prop({ default: 'Servicer' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop({ type: Boolean, default: false }) public clearable!: boolean;
    @Prop({ type: Boolean, default: false }) public includeUnknown!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ default: 'id' }) public valueField!: string;

    public source: ServicerSource | IServicer[] = [];

    public mounted() {
      this.source = new ServicerSource(true, this.includeUnknown);
    }

    public get val(): unknown { return this.value; }
    public set val(value: unknown) {
      this.$emit('input', value);
    }
  }
